import ButtonFilter from './ButtonFilter'

ButtonFilter.install = (Vue, options) => {
  Vue.component(ButtonFilter.name, ButtonFilter)
}
export default ButtonFilter


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/components/ButtonFilter/index.js
// module id = null
// module chunks = 